import { useParams } from 'react-router-dom'

import { useSiteGetApi } from '@/common/api/modules/site'

import DetailPageLoader from '@/components/container/DetailPageLoader'
import SiteEditPage from '@/components/container/page/admin/site/SiteEditPage'

const SiteUpdatePage = () => {
  const { siteId } = useParams()

  const { data, error, mutate } = useSiteGetApi({
    site_id: Number(siteId)
  })

  return (
    <DetailPageLoader error={error} data={data} withSide>
      <SiteEditPage site={data} onRefetch={() => mutate()} />
    </DetailPageLoader>
  )
}

export default SiteUpdatePage
